import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";

const FIELD_TYPES = ["text", "textarea", "number", "date", "checkbox", "dropdown", "multiselect", "phone", "email", "url"];

export default function CustomFieldsModal({ onClose }) {
  const [fields, setFields] = useState([]);
  const [name, setName] = useState("");
  const [fieldType, setFieldType] = useState("text");
  const [options, setOptions] = useState("");

  const load = () => { api.get("/admin/crm/custom-fields").then((r) => setFields(r.data)); };
  useEffect(() => { load(); }, []);

  const createField = async () => {
    if (!name.trim()) { toast.error("Field name is required"); return; }
    try {
      await api.post("/admin/crm/custom-fields", { name, field_type: fieldType, options: options.split(",").map((o) => o.trim()).filter(Boolean) });
      setName(""); setOptions(""); setFieldType("text");
      toast.success("Custom field created");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not create field");
    }
  };

  const deleteField = async (id) => {
    await api.delete(`/admin/crm/custom-fields/${id}`);
    load();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="crm-custom-fields-modal">
      <div className="glass-panel rounded-2xl p-5 max-w-lg w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm font-semibold text-white">Custom Fields</p>
          <button onClick={onClose} data-testid="crm-close-custom-fields-btn"><X className="w-4 h-4 text-slate-400 hover:text-white" /></button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-2">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Field name" data-testid="crm-custom-field-name-input"
            className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-white sm:col-span-2" />
          <select value={fieldType} onChange={(e) => setFieldType(e.target.value)} data-testid="crm-custom-field-type-select"
            className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-white">
            {FIELD_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        {(fieldType === "dropdown" || fieldType === "multiselect") && (
          <input value={options} onChange={(e) => setOptions(e.target.value)} placeholder="Options (comma separated)" data-testid="crm-custom-field-options-input"
            className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-xs text-white mb-2" />
        )}
        <button onClick={createField} data-testid="crm-save-custom-field-btn"
          className="flex items-center gap-1.5 text-xs font-semibold bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-300 px-3 py-2 rounded-lg mb-4">
          <Plus className="w-3.5 h-3.5" /> Add Field
        </button>
        <div className="space-y-2">
          {fields.map((f) => (
            <div key={f.id} className="flex items-center justify-between bg-white/5 rounded-lg px-3 py-2" data-testid={`crm-custom-field-row-${f.id}`}>
              <div><p className="text-xs text-white">{f.name}</p><p className="text-[10px] text-slate-500">{f.field_type} · key: {f.key}</p></div>
              <button onClick={() => deleteField(f.id)} data-testid={`crm-delete-custom-field-btn-${f.id}`}><Trash2 className="w-3.5 h-3.5 text-red-400 hover:text-red-300" /></button>
            </div>
          ))}
          {fields.length === 0 && <p className="text-xs text-slate-500">No custom fields yet.</p>}
        </div>
      </div>
    </div>
  );
}
